export const EXPERIMENT_NAME_RELEASE_SWITCH_HOME_ONE = 'home-one'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_ERX = 'erx'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_ERX_ADYEN = 'erx-adyen'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_ERX_NOW = 'erx-now'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_VARIANT_ATTRIBUTES =
  'variant-attributes'
export const EXPERIMENT_NAME_RELEASE_TOGGLE_HOME_ONE_CMS = 'h1-cms'
export const EXPERIMENT_NAME_HOME_ONE_CART = 'h1-cart'
export const EXPERIMENT_NAME_ODS_VC_MODAL = 'wsssh-188'
export const EXPERIMENT_NAME_ERX_ADYEN_MP = 'erx-adyen-mp'
export const EXPERIMENT_NAME_ACCOUNT_OVERVIEW_NOTEPAD_WIDGET = 'wscnl-7438'
export const EXPERIMENT_NAME_ODP_RATEPAY_PAYMENT = 'itet-1078'
export const EXPERIMENT_NAME_PERSONAL_ADVICE_DIALOG = 'wscnl-9727'
export const EXPERIMENT_NAME_FULLSTORY_TRACKING = 'pdcil-723'
export const EXPERIMENT_CHANGE_GTM_SCRIPT = 'cro-4910'
export const EXPERIMENT_NAME_RATEPAY_BUYER_PORTAL = 'wstra-12561'
export const EXPERIMENT_NAME_COMPOSITION_API = 'wsawa-7975'
export const EXPERIMENT_NAME_ALGOLIA_INDEX = 'alg'
export const EXPERIMENT_NAME_GET_CART_V4 = 'wsawa-7452'
export const EXPERIMENT_NAME_AD_SERVER_NEW_AD_SIZE_SEARCH_BANNER = 'rmadt-3648'
export const EXPERIMENT_NAME_RETURN_ARTICLE = 'pdtra-99'
export const EXPERIMENT_NAME_REMOVE_BANNERS = 'itrt-340'
export const EXPERIMENT_NAME_MODIFY_REGISTRATION = 'itsh-1161'
export const EXPERIMENT_NAME_AD_SERVER_SEARCH_SUGGEST = 'rmadt-3857'
export const EXPERIMENT_NAME_PUDO_POSTNL = 'itrt-1109'
export const EXPERIMENT_NAME_PUDO_EXTEND_POSTE_ITALIANE = 'itrtd-1882'
export const EXPERIMENT_NAME_PDP_AVAILABLE = 'itrt-3772'
export const EXPERIMENT_NAME_A2C_RECOMMENDATION_SERVICE = 'itrt-3721'
export const EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION = 'itrt-2180'
export const EXPERIMENT_NAME_CART_RECOMMENDATION_WIDGET_ORDER = 'itrt-4307'
export const EXPERIMENT_NAME_PDP_AVAILABLE_RECOMMENDATION_SERVICE = 'itrt-4297'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_HOME_TOP = 'cro-7028'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_ACCOUNT = 'gk-acc'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_CART = 'gk-cart'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_CATEGORY = 'gk-cat'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_ADD_TO_CART = 'gk-a2c'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_AVAILABLE = 'gk-pdp'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_DELIVERY_TRACKING =
  'gk-delt'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_REDPOINTS = 'gk-red'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_INACTIVITY_MODAL = 'gk-inac'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_NO_RESULT_PAGE = 'gk-nores'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION =
  'gk-pdpex'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_RX = 'gk-pdprx'
export const EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_UNAVAILABLE = 'gk-pdpun'
export const EXPERIMENT_NAME_H1_ORDER_DETAILS_PAGE_MIGRATION = 'itrt-1050'
export const EXPERIMENT_NAME_NFC_LANDING_PAGE_NEUTRAL_VARIANT = 'itrx-3363'
export const EXPERIMENT_NAME_SIMPLIFY_SHIPPING_STEP = 'itrt-3003'
export const EXPERIMENT_NAME_SIMPLIFY_SHIPPING_STEP_RETEST = 'itrt-4093'
export const EXPERIMENT_NAME_LOGIN_TWO_STEP = 'itsh-1786'
export const EXPERIMENT_NAME_ZERO_EURO_COPAYMENT_TOGGLE = 'itrx-2264'
export const EXPERIMENT_NAME_RX_PDP_APP_REDEMPTION = 'itrx-3176'
export const EXPERIMENT_NAME_PACKAGE_TAX = 'itrtd-2971'
